import { render, staticRenderFns } from "./DialogDetailGroupEmail.vue?vue&type=template&id=5c11c12c&"
import script from "./DialogDetailGroupEmail.vue?vue&type=script&lang=js&"
export * from "./DialogDetailGroupEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports